/**
 * =============================================================================
 *  THU TU CAC DONG TRONG BANG DOI TUONG
 * =============================================================================
 *
 *  Tach ra khoi ObjectPanel.tsx vi day la mot LOI HUA, khong phai mot chi tiet
 *  trinh bay: dong tren cung cua bang phai la doi tuong nam TREN CUNG trong tep
 *  xuat ra. Nam trong JSX thi khong kiem chung duoc bang test (bo chay test la
 *  node --test, khong bien dich JSX), va cai gi khong kiem chung duoc thi da
 *  tung troi - xem core/annotations/order.ts.
 *
 *  Quy tac, day du:
 *    1. Danh sach di vao DA sap theo `z` tang dan (kho trang thai giu nhu vay
 *       qua sortAnnotationsByZ, va duong ghi gan /Annots theo dung thu tu do).
 *    2. Loc lay doi tuong cua trang dang xem - theo chi so TAI LIEU GOC.
 *    3. DAO NGUOC de hien: tren cung cua bang = tren cung cua chong lop.
 *
 *  Khong co buoc sap xep thu tu nao khac. Them mot tieu chi sap xep rieng o day
 *  (thoi diem tao, ten, ma) la lam cho bang noi doi ve tep.
 */
import type { Annotation } from '@pdfeditor/types';

/**
 * Cac dong cua bang, tu TREN xuong DUOI.
 *
 * `pageIndex` la chi so trang trong tai lieu goc; null nghia la chua biet trang
 * nao dang xem, va khi do bang khong liet ke gi ca thay vi liet ke bua.
 */
export function objectRowsForPage(
  annotations: readonly Annotation[],
  pageIndex: number | null,
): Annotation[] {
  if (pageIndex === null) return [];
  const onPage = annotations.filter((a) => a.pageIndex === pageIndex);
  return onPage.reverse();
}
